export const HIDE_HEADER = 'UI/HIDE_HEADER';

export const SHOW_MODAL = 'UI/SHOW_MODAL';
export const HIDE_MODAL = 'UI/HIDE_MODAL';

export const SET_LOADER_STATE = 'UI/SET_LOADER_STATE';

export const HIDE_PROGRESS_BAR = 'UI/HIDE_PROGRESS_BAR';

export const INIT_FRONT_CHAT = 'UI/INIT_FRONT_CHAT';

export const HIDE_PAYPAL = 'UI/HIDE_PAYPAL';

export const SET_FONT_FAMILY = 'SET_FONT_FAMILY';

export const SET_THEME_NAME = 'SET_THEME_NAME';
